import { DriverInformationFieldNames } from '@contracts/order/fields/DriverInformationFields';
import { StringField } from '@src/permitField/PermitFields';
import * as yup from 'yup';

export class DriverIdField extends StringField {
  public static fieldName = DriverInformationFieldNames.DriverId;
  public static validator = yup.string().optional();
}

export class DriverNameField {
  public static fieldName = DriverInformationFieldNames.DriverName;
  public static validator = yup.string().trim().required();
}

export class DriverLicenseNumberField {
  public static fieldName = DriverInformationFieldNames.DriverLicenseNumber;
  public static validator = yup.string().trim().required();
}

export class DriverEmailField {
  public static fieldName = DriverInformationFieldNames.DriverEmail;
  public static validator = yup.string().trim().email();
}

export class DriverPhoneField {
  public static fieldName = DriverInformationFieldNames.DriverPhone;
  public static validator = yup.string().trim();
}

export const driverInformationFields = {
  [DriverNameField.fieldName]: DriverNameField.validator,
  [DriverEmailField.fieldName]: DriverEmailField.validator,
  [DriverPhoneField.fieldName]: DriverPhoneField.validator,
  [DriverLicenseNumberField.fieldName]: DriverLicenseNumberField.validator,
} as const;
